// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__by-Bb","image":"Header_image__1wyYD","name":"Header_name__3XKFo","info":"Header_info__3X0-0","infoRow":"Header_infoRow__39RD2"};